var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAliviaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 46,
    viewBox: "0 0 192 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3593 27.7472H82.0414L78.7003 20.9024L75.3593 27.7472ZM65.0391 36.8L78.7003 9.27359L92.3616 36.8H86.1992L84.1945 32.6784H73.2061L71.2015 36.8H65.0391Z",
    fill: "#003B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7773 36.8V10.7456H101.569V31.5744H111.74V36.8H95.7773Z",
    fill: "#003B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.615 10.7456H115.824V36.7264H121.615V10.7456Z",
    fill: "#003B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.468 38.0512L125.029 10.7456H131.192L138.468 26.0544L145.818 10.7456H151.981L138.468 38.0512Z",
    fill: "#003B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.113 10.7456H155.322V36.7264H161.113V10.7456Z",
    fill: "#003B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.998 27.7472H181.68L178.339 20.9024L174.998 27.7472ZM164.678 36.8L178.339 9.27359L192 36.8H185.838L183.833 32.6784H172.845L170.84 36.8H164.678Z",
    fill: "#003B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0766 33.5616L24.4269 19.7984L28.5847 27.8208L17.0766 33.5616ZM47.3689 27.7472L49.2251 31.28L58.1346 17.664L41.8005 16.8544L43.6566 20.3872L36.9745 23.6992L24.5754 0L0 46H10.7657L32.297 35.1808L37.8654 46H48.3341L40.6125 31.1328L47.3689 27.7472Z",
    fill: "#11C0F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_1312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliviaLogo);
export default __webpack_public_path__ + "static/media/Alivia_logo.34b27258b1622b3985b0aad8605eec7a.svg";
export { ForwardRef as ReactComponent };